import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class HidescrollnavService {

  public headerFixed: boolean = false;

}
